{
  "name": "@nsc/smartteams",
  "displayName": "NSC SmartTeams",
  "description": "NSC SmartTeams - User and Availability Management",
  "version": "1.0.11",
  "private": true,
  "type": "module",
  "scripts": {
    "build": "adornis-cli project build --production --node-port 7000 --listen-port 3000",
    "generate:fe-import": "node scripts/generate-sn-fe-import.ts",
    "test": "adornis-cli project test"
  },
  "dependencies": {
    "@adornis/abac": "^2.0.9",
    "@adornis/address": "^24.1.11",
    "@adornis/authentication": "^25.0.11",
    "@adornis/base": "^16.1.0",
    "@adornis/baseql": "^19.1.1",
    "@adornis/browser-shim": "^2.0.2",
    "@adornis/calendar": "^19.0.19",
    "@adornis/chemistry": "^19.0.19",
    "@adornis/config": "^11.2.0",
    "@adornis/data-view": "^35.0.15",
    "@adornis/dialog": "^19.0.20",
    "@adornis/entity-picker": "^14.0.15",
    "@adornis/entity-relationship-management": "^11.0.17",
    "@adornis/file-utils": "^24.0.14",
    "@adornis/filter": "^14.0.15",
    "@adornis/fonts": "^19.0.19",
    "@adornis/formfield": "^20.4.5",
    "@adornis/forms": "^26.0.13",
    "@adornis/functional-lit": "6.2.6",
    "@adornis/generated-form": "^15.0.17",
    "@adornis/internationalization": "^27.0.13",
    "@adornis/mails": "^34.0.15",
    "@adornis/mongodb": "^1.0.5",
    "@adornis/popover": "^26.0.13",
    "@adornis/router": "^8.1.3",
    "@adornis/ssr": "^13.0.28",
    "@adornis/user-forms": "^26.0.14",
    "@adornis/users": "^22.0.8",
    "@adornis/validation": "^13.1.0",
    "@iconify-json/mdi": "^1.2.3",
    "@lit-labs/preact-signals": "^1.0.3",
    "@nsc/servicenow": "workspace:*",
    "@nsc/simple-lms": "workspace:*",
    "@nsc/smartteams-shared": "workspace:^",
    "construct-style-sheets-polyfill": "^3.1.0",
    "daisyui": "5.6.0",
    "express": "^5.2.1",
    "fast-csv": "^5.0.7",
    "lit": "^3.3.3",
    "mongodb": "^7.4.0",
    "rxjs": "^7.8.2"
  },
  "devDependencies": {
    "@adornis/cli": "^1.8.2",
    "xlsx": "^0.18.5"
  },
  "files": [
    "dist"
  ],
  "license": "ISC"
}
